import api from "./api"

export async function editModel(nBoardId, aData) {
  const response = await api.patch(`/op-panel/board-models/${nBoardId}`, {
    fields: aData,
  })
  return response
}
